// prettier-ignore
import { type ProctorSpecification } from '../../../shared/proctor/ProctorSpecification';

export const DiscoLimitedUiTst = {
    name: 'disco_limited_ui_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
        Grp2: 2,
    },
} satisfies ProctorSpecification;

export type DiscoLimitedUiTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
    isGrp2: boolean;
};

export const JcsReportJobTst = {
    name: 'jcs_report_job_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
        Grp2: 2,
    },
} satisfies ProctorSpecification;

export type JcsReportJobTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
    isGrp2: boolean;
};

export const RnNpsParentTst = {
    name: 'rn_nps_parent_tst',
    buckets: {
        Rotate: -2,
        Inactive: -1,
        Control: 0,
        Shownps: 1,
    },
} satisfies ProctorSpecification;

export type RnNpsParentTstAllocation = {
    value: number;
    payloadJson: string | null;
    isRotate: boolean;
    isInactive: boolean;
    isControl: boolean;
    isShownps: boolean;
};

export const RnSerpNpsTst = {
    name: 'rn_serp_nps_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Shownps: 1,
    },
} satisfies ProctorSpecification;

export type RnSerpNpsTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isShownps: boolean;
};

export const SerpGigFilterTst = {
    name: 'serp_gig_filter_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
    },
} satisfies ProctorSpecification;

export type SerpGigFilterTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
};

export const SerpGroupingsFeedbackTst = {
    name: 'serp_groupings_feedback_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
    },
} satisfies ProctorSpecification;

export type SerpGroupingsFeedbackTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
};

export const SerpGroupingsTst = {
    name: 'serp_groupings_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
        Grp2: 2,
        Grp3: 3,
        Grp4: 4,
    },
} satisfies ProctorSpecification;

export type SerpGroupingsTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
    isGrp2: boolean;
    isGrp3: boolean;
    isGrp4: boolean;
};

export const SerpGroupingsUpliftTst = {
    name: 'serp_groupings_uplift_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
        Grp2: 2,
        Grp3: 3,
        Grp4: 4,
        Grp5: 5,
        Grp6: 6,
    },
} satisfies ProctorSpecification;

export type SerpGroupingsUpliftTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
    isGrp2: boolean;
    isGrp3: boolean;
    isGrp4: boolean;
    isGrp5: boolean;
    isGrp6: boolean;
};

export type SerpProctorSpecification =
    | typeof DiscoLimitedUiTst
    | typeof JcsReportJobTst
    | typeof RnNpsParentTst
    | typeof RnSerpNpsTst
    | typeof SerpGigFilterTst
    | typeof SerpGroupingsFeedbackTst
    | typeof SerpGroupingsTst
    | typeof SerpGroupingsUpliftTst;

export type SerpProctorAllocation =
    | DiscoLimitedUiTstAllocation
    | JcsReportJobTstAllocation
    | RnNpsParentTstAllocation
    | RnSerpNpsTstAllocation
    | SerpGigFilterTstAllocation
    | SerpGroupingsFeedbackTstAllocation
    | SerpGroupingsTstAllocation
    | SerpGroupingsUpliftTstAllocation;

export const SerpProctorSpecifications = [
    DiscoLimitedUiTst,
    JcsReportJobTst,
    RnNpsParentTst,
    RnSerpNpsTst,
    SerpGigFilterTst,
    SerpGroupingsFeedbackTst,
    SerpGroupingsTst,
    SerpGroupingsUpliftTst,
];